import React from 'react';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/pro-solid-svg-icons';

const StrategyProviderSearch = ({
  search,
  onSearch,
  inputRef,
}: {
  search: string;
  onSearch: (search: string) => void;
  inputRef?: React.RefObject<HTMLInputElement>;
}) => {
  return (
    <div className="w-full px-3.5 py-2 bg-neutral-100 rounded-full border border-neutral-300 flex items-center gap-2">
      <div className="w-4 h-4 flex items-center justify-center">
        <Icon icon={faSearch} className="text-neutral-600" size="sm" />
      </div>
      <input
        ref={inputRef}
        type="text"
        value={search}
        onChange={(e) => onSearch(e.target.value)}
        placeholder="Provider Name"
        className="flex-1 flex-shrink-0 text-sm font-normal font-['Inter'] leading-tight bg-transparent outline-none placeholder-neutral-500 text-neutral-900"
      />
    </div>
  );
};

export default StrategyProviderSearch;
